import { type LocationQueryValueRaw, useRoute, useRouter } from 'vue-router';
import type { RouteNames } from '@/core/plugins/router/routeNames';

export const useUpdateQuery = () => {
  const $router = useRouter();
  const $route = useRoute();

  const updateQuery = async (query: Record<string, LocationQueryValueRaw | LocationQueryValueRaw[]>) => {
    await $router.replace({ query: { ...$route.query, ...query } });
  };

  return updateQuery;
};

export const useOpenInNewTab = () => {
  const $router = useRouter();

  const openInNewTab = (name: RouteNames, params?: Record<string, string | number>) => {
    const routeData = $router.resolve({ name, params });
    window.open(routeData.href, '_blank');
  };

  return openInNewTab;
};
